export const CHANNEL_TYPES = {
  GRP: "GRP",
  PRV: "PRV",
  PUB: "PUB"
};
